import axiosHttp from "./interceptor.service";

// Every vault DATA call must carry the unlock token the user got after entering their vault
// password (stored in sessionStorage → cleared when the browser session ends → re-prompt).
const vaultCfg = () => ({ headers: { "x-vault-token": sessionStorage.getItem("vaultToken") || "" } });

// ── Access lock (per-user vault password) ──
const getVaultAccessStatus = () => axiosHttp.get("/lmt/vault/access/status");
const setVaultPassword = (data) => axiosHttp.post("/lmt/vault/access/set", data);
const verifyVaultPassword = (data) => axiosHttp.post("/lmt/vault/access/verify", data);

// ── Forgot-password flow ──
const requestVaultReset = () => axiosHttp.post("/lmt/vault/access/request-reset", {});
const getVaultResetRequests = () => axiosHttp.get("/lmt/vault/access/reset-requests");
const approveVaultReset = (userId) => axiosHttp.post("/lmt/vault/access/approve-reset", { userId });

// ── Masters ──
const createVaultMaster = (data) => axiosHttp.post("/lmt/vault/master", data, vaultCfg());
const getVaultMasters = () => axiosHttp.get("/lmt/vault/masters", vaultCfg());
const getVaultMaster = (id) => axiosHttp.get(`/lmt/vault/master/${id}`, vaultCfg());
const updateVaultMaster = (id, data) => axiosHttp.put(`/lmt/vault/master/${id}`, data, vaultCfg());
const deleteVaultMaster = (id) => axiosHttp.delete(`/lmt/vault/master/${id}`, vaultCfg());

// ── Records ── (FormData; browser sets multipart Content-Type, we only add the vault token)
const addVaultRecord = (formData) => axiosHttp.post("/lmt/vault/record", formData, vaultCfg());
const getVaultRecords = (masterId) => axiosHttp.get(`/lmt/vault/records/${masterId}`, vaultCfg());
const deleteVaultRecord = (id) => axiosHttp.delete(`/lmt/vault/record/${id}`, vaultCfg());
// Admin: set which users can view a specific record.
const updateVaultRecordAccess = (recordId, allowedUsers) =>
  axiosHttp.put(`/lmt/vault/record/${recordId}/access`, { allowedUsers }, vaultCfg());

export {
  getVaultAccessStatus,
  setVaultPassword,
  verifyVaultPassword,
  requestVaultReset,
  getVaultResetRequests,
  approveVaultReset,
  createVaultMaster,
  getVaultMasters,
  getVaultMaster,
  updateVaultMaster,
  deleteVaultMaster,
  addVaultRecord,
  getVaultRecords,
  deleteVaultRecord,
  updateVaultRecordAccess,
};
